<template>
  <v-list-item
      @click="$emit('click')"
      class="notifications-list-item"
      :class="{'is-new': isNew}"
  >
    <v-list-item-avatar>
      <v-avatar :color="avatarColor" size="48">
        <span class="white--text">{{ notification.fromEmail.substr(0, 2).toUpperCase() }}</span>
      </v-avatar>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-row dense justify="space-between" align="start">
        <v-col class="from-to">
          <p :class="textClass">{{ $t('notifications.item.from') }} {{ sender }}</p>
          <p :class="textClass">{{ $t('notifications.item.to') }} {{ receiver }}</p>
        </v-col>
        <v-col md="auto" cols="auto">
          <time :class="textClass" class="text-caption">{{ notification.sentDatetime.toLocaleDateString() }}</time>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <div :class="textClass" class="text-subtitle-2">{{ notification.messageHead }}</div>
          <div v-html="notification.messageText" class="notification-content text-caption"></div>
        </v-col>
      </v-row>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import strToColor from "@/utils/strToColor";

export default {
  props: {
    notification: Object,
  },
  computed: {
    textClass() {
      return this.isNew ? 'primary--text' : null;
    },

    avatarColor() {
      return strToColor(this.notification.fromEmail);
    },

    isNew() {
      return this.notification.isUnread && this.notification.fromEmail !== this.$store.getters["app/user"].email;
    },

    sender() {
      if (this.notification.fromEmail === this.$store.getters["app/user"].email) {
        const rhName = (this.$store.getters["app/rightsholder"](this.notification.fromId) || {name: `RH# ${this.notification.fromId}`}).name
        return `${rhName} [Me]`;
      }
      if (this.notification.fromId === this.$store.getters["app/adminId"]) {
        return 'Admin';
      }
      const rh = this.$store.getters["app/rightsholder"](this.notification.fromId);
      if (rh) {
        return rh.name;
      }
      return this.notification.fromEmail;
    },

    receiver() {
      if (this.notification.receiverId === 0) {
        return this.$t('notifications.item.all')
      }
      if (this.notification.receiverId === this.$store.getters["app/adminId"]) {
        return this.$t('notifications.item.admin');
      }
      const rh = this.$store.getters['app/rightsholder'](this.notification.receiverId);
      if (rh) {
        return rh.name;
      }
      return 'RH# ' + this.notification.receiverId;
    }
  },
};
</script>

<style lang="scss" scoped>
.notifications-list-item {
  width: 100%;

  .row {
    width: 100%;
  }
}

.from-to {
  p {
    margin-bottom: 0;
    font-size: 11px;
    font-weight: bold;
  }
}

.notification-content {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
}
</style>